@if (listConfig?.variant === 'hub') {
  <wl-list-variant-hub
    [rendering]="rendering"
    [subVariant]="listConfig?.subVariant"
    [listConfig]="listConfig"
    [cardConfig]="cardConfig"
    trackImpression="contentblock-impression"
    [trackImpressionInfo]="rendering"
    [trackImpressionContext]="context"
  ></wl-list-variant-hub>
}
@if (listConfig?.variant === 'stepbystep') {
  <wl-list-variant-step-by-step
    [rendering]="rendering"
    [subVariant]="listConfig?.subVariant"
    [listConfig]="listConfig"
    [cardConfig]="cardConfig"
    trackImpression="contentblock-impression"
    [trackImpressionInfo]="rendering"
    [trackImpressionContext]="context"
  ></wl-list-variant-step-by-step>
}
@if (listConfig?.variant === 'minimal') {
  <wl-list-variant-minimal
    [rendering]="rendering"
    [subVariant]="listConfig?.subVariant"
    [listConfig]="listConfig"
    trackImpression="contentblock-impression"
    [trackImpressionInfo]="rendering"
    [trackImpressionContext]="context"
  ></wl-list-variant-minimal>
}
